import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { HookDirective } from '../core/hook';
import { useSubscriptionLatest } from '../core/hooks';
import { AdvancedFilterMultiSelectSimpleComponent } from './advanced-filter-multi-select-simple.component';

let id = 0;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'advanced-filter-checkbox',
  templateUrl: './advanced-filter-checkbox.component.html',
  styleUrls: ['./advanced-filter-checkbox.component.scss'],
})
export class AdvancedFilterCheckboxComponent<T> extends HookDirective {
  readonly id = `advanced-filter-checkbox-${id++}`;

  @Input()
  label: string;

  @Input()
  count: number | null;

  @Input()
  value: T;

  constructor(
    changeDetector: ChangeDetectorRef,
    private readonly parentComponent: AdvancedFilterMultiSelectSimpleComponent<
      string,
      T
    >,
  ) {
    super(changeDetector);
  }

  get _() {
    const parentSelected = useSubscriptionLatest(
      this.parentComponent.selected,
      [],
    );
    const selected = !!parentSelected && parentSelected.includes(this.value);

    const changeSelected = (value: boolean) =>
      this.parentComponent.changeSelected(this.value, value);

    return {
      selected,
      changeSelected,
    };
  }
}
